/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Customer_Contract_Prepaid_RequiredInputs */



/**
* | output |
* | --- |
* | "Enter the prepaid usage budget — it must be more than zero." |
*
* @param {Partner_Add_Customer_Contract_Prepaid_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_customer_contract_prepaid_required = /** @type {((inputs?: Partner_Add_Customer_Contract_Prepaid_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Customer_Contract_Prepaid_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie das vorausbezahlte Nutzungsbudget ein — es muss größer als null sein.")
	return /** @type {LocalizedString} */ ("Enter the prepaid usage budget — it must be more than zero.")
});